const GridPagingComponent = {
    templateUrl: '/ui/user/paging/gridPaging.tpl.html',
    controller: 'gridPagingController',
    bindings: {
        startIndex: '<',
        pageSize: '<',
        totalRecords: '<',
        recordCountText: '<',
        recordsCountText: '<',
        onChange: '&'
    }
};

angular.module('umCore')
    .component('uiGridPagingComponent', GridPagingComponent);

